import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import TextInput from '../../../common/TextInput/';
import { resetPasswordRequested, clearErrorMessages } from './../actions';
import LoadingComponent from '../../../common/LoadingComponent';
import './styles.scss';
import { getResetPasswordError, getResetPasswordLoading } from '../selectors';

function ResetForm({
    resettingPassword,
    onPasswordChanged,
    errorMessage,
    clearErrorState,
}) {
    const [password, setPassword] = useState('');
    const [cPassword, setCPassword] = useState('');

    useEffect(() => {
        clearErrorState();
    }, []);

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={resettingPassword} />
        </div>
    );

    const buttonText = resettingPassword ? loader : 'Reset';
    return (
        <>
            {errorMessage ? <p>{errorMessage}</p> : null}
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onPasswordChanged(password);
                }}
            >
                <div className="filter-form">
                    <h2 className="mb-24 loginTitle">Reset Password</h2>
                    <div className="signin-seperator">
                        <div className="signin-divider"></div>
                    </div>
                    <div className="customInput">
                        <h3 className="titleStyle2">Password</h3>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text icon2-open"></span>
                            </div>
                            <TextInput
                                type="password"
                                onChange={(event) =>
                                    setPassword(event.target.value)
                                }
                                value={password}
                                required="required"
                                placeholder={'password'}
                            />
                        </div>
                    </div>
                    <div className="customInput">
                        <h3 className="titleStyle2">Confirm Password</h3>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text icon2-open"></span>
                            </div>
                            <TextInput
                                type="password"
                                onChange={(event) =>
                                    setCPassword(event.target.value)
                                }
                                value={cPassword}
                                required="required"
                                placeholder={'confirm password'}
                            />
                        </div>
                    </div>

                    <button
                        disabled={!password || password != cPassword}
                        type="submit"
                        className="btn btn-custom btn-block"
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </>
    );
}

ResetForm.propTypes = {
    // function to be called when form is submitted
    onPasswordChanged: PropTypes.func.isRequired,

    // error message to be shown when something goes wrong with login request
    errorMessage: PropTypes.string,

    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,

    resettingPassword: PropTypes.boolean,
};

ResetForm.defaultProps = {
    errorMessage: null,
    resettingPassword: false,
};

const mapStateToProps = (state) => {
    return {
        errorMessage: getResetPasswordError(state),
        resettingPassword: getResetPasswordLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPasswordChanged: (password) =>
            dispatch(resetPasswordRequested(password)),
        clearErrorState: () => dispatch(clearErrorMessages()),
    };
};

const ConnectedResetForm = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResetForm);

export default ConnectedResetForm;
